// spin-wheel.js
document.addEventListener("DOMContentLoaded", () => {
    const BACKEND_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? "http://localhost:3000"
        : "https://spinwheel-x608.onrender.com";
    const SHOP_DOMAIN = window.Shopify?.shop || "custom-store.com";

    // Load Canvas Confetti for the ultimate win effect
    const confettiScript = document.createElement('script');
    confettiScript.src = "https://cdn.jsdelivr.net/npm/canvas-confetti@1.6.0/dist/confetti.browser.min.js";
    document.head.appendChild(confettiScript);

    // Pre-warm the Render backend server in case it is sleeping (Free Tier)
    // This gives it a head start to wake up while the user is browsing!
    fetch(BACKEND_URL).catch(() => {});

    // Inject the Modal HTML & Sticky Tab
    const wheelHTML = `
        <div class="spin-wheel-sticky-tab" id="spinWheelStickyTab">🎁 Spin & Win</div>
        <div class="spin-wheel-overlay" id="spinWheelOverlay">
            <div class="spin-wheel-modal">
                <span class="spin-wheel-close" id="spinWheelClose">&times;</span>
                <h2>Navratri Special Spin!</h2>
                <div class="wheel-container">
                    <div class="wheel-pointer"></div>
                    <div class="wheel" id="wheel">
                        <!-- Slices and text will be injected here -->
                    </div>
                </div>
                
                <div id="spinWheelFormContainer" style="width: 100%">
                    <form class="spin-wheel-form" id="spinWheelForm">
                        <input type="text" id="swName" placeholder="Your Name" required />
                        <input type="email" id="swEmail" placeholder="Your Email" required />
                        <input type="tel" id="swPhone" placeholder="Your Phone" required />
                        <button type="submit" class="spin-wheel-btn">Spin to Win</button>
                    </form>
                </div>
                
                <div id="spinWheelResult" style="display: none; text-align: center; width: 100%; flex-direction: column; align-items: center;">
                    <div style="background: rgba(0,0,0,0.5); padding: 15px; border-radius: 12px; border: 1px solid rgba(255,215,0,0.3); margin-top: 10px; width: 100%;">
                        <h3 id="swResultText" style="color: #FFF8DC; font-size: 1.3rem; margin: 0 0 10px 0; font-weight: 500; text-shadow: 0 2px 4px rgba(0,0,0,0.8); font-family: 'Outfit', sans-serif;"></h3>
                        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; background: rgba(255,215,0,0.1); padding: 10px 15px; border-radius: 8px; border: 1px dashed var(--navratri-gold); margin-bottom: 5px;">
                            <span id="swDiscountCode" style="font-size: 1.4rem; font-weight: 800; color: var(--navratri-gold); margin: 0; letter-spacing: 1px;"></span>
                            <button id="swCopyBtn" style="padding: 8px 16px; background: linear-gradient(135deg, #FFD700, #FFA500); color: #000; border: none; border-radius: 6px; cursor: pointer; font-weight: 800; display: none; font-family: 'Outfit', sans-serif; box-shadow: 0 4px 10px rgba(255,215,0,0.3); transition: transform 0.2s;">Copy</button>
                        </div>
                    </div>
                    <div class="urgency-timer-container" id="urgencyTimerContainer" style="width: 100%; margin-top: 15px;">
                        <div class="urgency-timer-text">Offer Expires In:</div>
                        <div class="urgency-timer" id="urgencyTimer">48:00:00</div>
                    </div>
                    <button class="spin-wheel-btn" id="swContinueBtn" style="margin-top:20px; width: 100%;">Continue Shopping</button>
                </div>
            </div>
        </div>
    `;

    document.body.insertAdjacentHTML('beforeend', wheelHTML);

    const overlay = document.getElementById('spinWheelOverlay');
    const stickyTab = document.getElementById('spinWheelStickyTab');
    const close = document.getElementById('spinWheelClose');
    const form = document.getElementById('spinWheelForm');
    const wheel = document.getElementById('wheel');
    const resultContainer = document.getElementById('spinWheelResult');
    const formContainer = document.getElementById('spinWheelFormContainer');

    // Define Prizes and Colors
    const prizes = [
        "10% OFF", "15% OFF", "FREE GIFT",
        "FREE SHIP", "20% OFF", "TRY AGAIN"
    ];
    const colors = ['#a71d1d', '#d4af37', '#d86a03', '#ffc107', '#1b5e20', '#ff8f00'];

    // Construct Wheel Slices and Text
    let conicString = "";
    const sliceAngle = 360 / prizes.length;

    prizes.forEach((prize, i) => {
        const startAngle = i * sliceAngle;
        const endAngle = startAngle + sliceAngle;
        conicString += `${colors[i]} ${startAngle}deg ${endAngle}deg${i === prizes.length - 1 ? '' : ','} `;

        // Inject Text Div
        const textDiv = document.createElement('div');
        textDiv.className = 'wheel-text';
        // Rotate text to the center of the slice (start + half slice)
        textDiv.style.transform = `rotate(${startAngle + (sliceAngle / 2)}deg)`;
        textDiv.innerHTML = prize.replace(' ', '<br>');
        wheel.appendChild(textDiv);
    });

    wheel.style.background = `conic-gradient(${conicString})`;

    // Helper: Show/Hide Modals
    const openModal = () => {
        document.body.style.overflow = 'hidden'; // Lock background scrolling and hide browser scrollbar
        overlay.classList.add('active');
        stickyTab.style.display = 'none';
    };

    const closeModal = () => {
        document.body.style.overflow = ''; // Restore background scrolling
        overlay.classList.remove('active');
        stickyTab.style.display = 'block'; // Show sticky tab when closed
        if (window.confetti) confetti.reset();
    };

    // Advanced URL Targeting Rules
    const currentPath = window.location.pathname;

    // Rule 1: Show the popup immediately on all pages (if they haven't completed it)
    if (!localStorage.getItem('spinWheelCompleted')) {
        setTimeout(() => {
            openModal();

            // Auto-close after 5 seconds
            let autoCloseTimer = setTimeout(() => {
                closeModal();
            }, 5000);

            // Cancel the auto-close timer if the user hovers, clicks, or types in the modal
            const cancelAutoClose = () => clearTimeout(autoCloseTimer);
            overlay.addEventListener('mouseenter', cancelAutoClose);
            overlay.addEventListener('click', cancelAutoClose);
            overlay.addEventListener('touchstart', cancelAutoClose);
            overlay.addEventListener('focusin', cancelAutoClose);

        }, 5000);
    }

    // Rule 2: Products & Cart get Exit-Intent strictly
    if (currentPath.includes('/products') || currentPath.includes('/cart')) {
        document.addEventListener('mouseleave', (e) => {
            if (e.clientY < 0 && !localStorage.getItem('spinWheelCompleted')) {
                openModal();
            }
        });
    }

    // Default Fallback: Always show sticky tab
    stickyTab.style.display = 'block';

    // Triggers: Attach event listener to ANY button with the class .navratri-trigger-btn
    const customTriggers = document.querySelectorAll('.navratri-trigger-btn');
    customTriggers.forEach(btn => {
        btn.addEventListener('click', openModal);
    });

    stickyTab.addEventListener('click', openModal);
    close.addEventListener('click', closeModal);
    document.getElementById('swContinueBtn').addEventListener('click', closeModal);

    // If they already won, show the result container instead of the spin wheel when opened
    function checkPreviousWin() {
        if (localStorage.getItem('spinWheelCompleted')) {
            formContainer.style.display = 'none';
            resultContainer.style.display = 'block';

            const savedPrize = localStorage.getItem('spinWheelPrize');
            const savedCode = localStorage.getItem('spinWheelCode');

            if (savedPrize) {
                if (savedPrize.toUpperCase() === 'TRY AGAIN') {
                    document.getElementById('swResultText').innerHTML = `Oops! ${savedPrize}!`;
                } else {
                    document.getElementById('swResultText').innerHTML = `You won: ${savedPrize}!`;
                }
            }
            if (savedCode) {
                document.getElementById('swDiscountCode').innerText = `Code: ${savedCode}`;
                const copyBtn = document.getElementById('swCopyBtn');
                copyBtn.style.display = 'block';
                copyBtn.onclick = () => {
                    navigator.clipboard.writeText(savedCode);
                    copyBtn.innerText = "Copied!";
                    setTimeout(() => { copyBtn.innerText = "Copy"; }, 2000);
                };
            }
        }
    }

    // Call it immediately in case modal is somehow visible, but it will mostly apply when modal opens
    checkPreviousWin();

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const name = form.querySelector('input[type="text"]').value;
        const email = form.querySelector('input[type="email"]').value;
        const phone = form.querySelector('input[type="tel"]').value;

        // Basic Email Validation to block generic disposable structures
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(email) || email.includes("test.com") || email.includes("fake.com")) {
            alert("Please enter a valid, real email address to spin.");
            return;
        }

        const submitBtn = form.querySelector('.spin-wheel-btn');
        submitBtn.innerText = "Spinning...";
        submitBtn.disabled = true;

        let currentRotation = 0;
        let isFetching = true;

        const spinAnimation = () => {
            if (!isFetching) return;
            currentRotation += 8; // Adjust speed
            wheel.style.transform = `rotate(${currentRotation}deg)`;
            requestAnimationFrame(spinAnimation);
        };

        wheel.style.transition = 'none';
        requestAnimationFrame(spinAnimation);

        try {
            // Prevent infinite spinning if the backend is slow or hangs
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 15000); // 15-second timeout for Render Wakeup

            // Call the real backend API
            const response = await fetch(`${BACKEND_URL}/api/spin`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ shopDomain: SHOP_DOMAIN, name, email, phone }),
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                throw new Error("Backend spin failed");
            }

            const data = await response.json();
            // Expected data format: { prize: '10% OFF', prizeIndex: 0, discountCode: 'SPIN10-XXXX' }

            isFetching = false;

            const winningAngle = (data.prizeIndex * sliceAngle) + (sliceAngle / 2);
            const currentMod = currentRotation % 360;
            let targetMod = 360 - winningAngle;
            let degreesToAdd = targetMod - currentMod;
            if (degreesToAdd < 0) {
                degreesToAdd += 360;
            }

            const finalRotation = currentRotation + degreesToAdd + (360 * 3);

            requestAnimationFrame(() => {
                wheel.style.transition = 'transform 2.5s cubic-bezier(0.1, 0.8, 0.1, 1)';
                wheel.style.transform = `rotate(${finalRotation}deg)`;
            });

            setTimeout(() => {
                localStorage.setItem('spinWheelCompleted', 'true');
                localStorage.setItem('spinWheelPrize', data.prize);
                if (data.discountCode) {
                    localStorage.setItem('spinWheelCode', data.discountCode);
                }
                if (data.selectedVariantId) {
                    localStorage.setItem('spinWheelFreeGiftId', data.selectedVariantId);
                }

                formContainer.style.display = 'none';
                resultContainer.style.display = 'block';

                let resultMsg = data.prize.toUpperCase() === 'TRY AGAIN' ? `Oops! ${data.prize}!` : `You won: ${data.prize}!`;
                if (data.selectedVariantId) {
                    resultMsg += `<br><span style="font-size:0.9rem; font-weight:normal;">(Item automatically added to your cart! Redirecting...)</span>`;

                    // Add item to cart and apply discount, then redirect to cart
                    fetch(window.location.origin + '/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: [{ id: data.selectedVariantId, quantity: 1 }] })
                    }).then(() => {
                        setTimeout(() => {
                            if (data.discountCode) {
                                // Redirect to /discount/CODE which sets the cookie, then to /cart?discount=CODE so Razorpay reads it
                                window.location.href = '/discount/' + data.discountCode + '?redirect=/cart%3Fdiscount=' + data.discountCode;
                            } else {
                                window.location.href = '/cart';
                            }
                        }, 1000);
                    }).catch(console.error);
                }
                document.getElementById('swResultText').innerHTML = resultMsg;
                if (data.discountCode) {
                    document.getElementById('swDiscountCode').innerText = `Code: ${data.discountCode}`;

                    // If no variant ID, just auto-apply the discount behind the scenes
                    if (!data.selectedVariantId) {
                        fetch(window.location.origin + '/discount/' + data.discountCode).catch(console.error);
                    }

                    const copyBtn = document.getElementById('swCopyBtn');
                    copyBtn.style.display = 'block';
                    copyBtn.onclick = () => {
                        navigator.clipboard.writeText(data.discountCode);
                        copyBtn.innerText = "Copied!";
                        setTimeout(() => { copyBtn.innerText = "Copy"; }, 2000);
                    };

                    // Show Timer and Start Countdown (24 Hours)
                    const timerContainer = document.getElementById('urgencyTimerContainer');
                    const timerText = document.getElementById('urgencyTimer');
                    timerContainer.style.display = 'block';

                    let timeLeft = 48 * 60 * 60; // 48 hours in seconds
                    const countdown = setInterval(() => {
                        timeLeft--;
                        const h = Math.floor(timeLeft / 3600).toString().padStart(2, '0');
                        const m = Math.floor((timeLeft % 3600) / 60).toString().padStart(2, '0');
                        const s = (timeLeft % 60).toString().padStart(2, '0');
                        timerText.innerText = `${h}:${m}:${s}`;
                        if (timeLeft <= 0) clearInterval(countdown);
                    }, 1000);
                }

                // Fire Confetti!
                if (window.confetti) {
                    // Left blast
                    confetti({
                        particleCount: 150,
                        angle: 60,
                        spread: 80,
                        origin: { x: 0, y: 0.7 },
                        zIndex: 9999999, // Blast the confetti IN FRONT of the overlay!
                        colors: ['#FFD700', '#B8860B', '#FFF8DC', '#FF8C00', '#FF0000']
                    });
                    // Right blast
                    confetti({
                        particleCount: 150,
                        angle: 120,
                        spread: 80,
                        origin: { x: 1, y: 0.7 },
                        zIndex: 9999999, 
                        colors: ['#FFD700', '#B8860B', '#FFF8DC', '#FF8C00', '#FF0000']
                    });
                    // Center blast slightly later
                    setTimeout(() => {
                        confetti({
                            particleCount: 200,
                            spread: 120,
                            origin: { y: 0.6 },
                            zIndex: 9999999,
                            colors: ['#FFD700', '#FFF8DC', '#FF8C00']
                        });
                    }, 400);
                }

            }, 2700);

        } catch (err) {
            isFetching = false;
            console.error('Spin Failed:', err);
            alert("Error: Something went wrong while connecting to the server. Please try again.");
            submitBtn.innerText = "Spin to Win";
            submitBtn.disabled = false;
        }
    });

    // The cart enforcer logic has been moved to cart-enforcer.js (App Embed) to run globally on all pages.

});
